import { Component } from '@angular/core';

@Component({
  selector: 'edgvr-front-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {}
